import React from "react";
import { ScreenGtLg } from "app/components/MediaQueries";
import { useIsLargeScreen } from "hooks/index";
import zendesk from "helpers/zendesk";
import Alert from "app/components/Alert";
import SpanLink from "app/components/SpanLink";
import Div from "app/components/Div";
import { CloseCircle } from "app/components/Icon";
import IconButton from "app/components/Button/IconButton";
import { SubscribeModalContext } from "../context";
import styles from "../shared-styles.module.scss";
import { DesktopModal, MobileModal } from "../shared-components";

interface MobileSubscriberModalProps {
  closeModal: () => void;
}

export function MobileSubscriberModal({
  closeModal,
}: MobileSubscriberModalProps) {
  const isLargeScreen = useIsLargeScreen();

  const Modal = isLargeScreen ? DesktopModal : MobileModal;
  return (
    <SubscribeModalContext.Provider value={{ closeModal }}>
      <ScreenGtLg>
        <Modal
          onEscapeKeydown={closeModal}
          onBackgroundClick={closeModal}
          isOpen
        >
          <Div p="12px">
            <div className={styles.closeButtonWrapper}>
              <h4>Upgrade Subscription</h4>
              <IconButton
                Icon={CloseCircle}
                onClick={closeModal}
                width="25px"
                height="25px"
                color="monochrome.5"
              />
            </div>

            <Alert variant="danger" margin="0">
              Your subscription was created through the STEEZY Studio{" "}
              <a
                href="https://apps.apple.com/app/steezy-learn-how-to-dance/id1296001664"
                target="blank"
              >
                iOS
              </a>{" "}
              or{" "}
              <a
                href="https://play.google.com/store/apps/details?id=co.steezy.app"
                target="blank"
              >
                Android
              </a>{" "}
              mobile app. To upgrade your subscription, please open the app on
              your mobile device or{" "}
              <SpanLink onClick={() => zendesk("webWidget", "open")}>
                contact us for help!
              </SpanLink>
            </Alert>
          </Div>
        </Modal>
      </ScreenGtLg>
    </SubscribeModalContext.Provider>
  );
}
